import React from "react";
export default class MealBuilderNavigation extends React.PureComponent {
    render() {
        const { dayNumber, totalDays, onSwitch } = this.props;
        return (React.createElement("div", null,
            React.createElement("br", null),
            React.createElement("div", { className: "split-btn-row" },
                dayNumber > 1 &&
                    React.createElement("a", { href: "#", className: "btn btn-outline-cta btn-lg d-inline-block", onClick: () => onSwitch(dayNumber - 1) },
                        React.createElement("i", { className: "far fa-chevron-left" }),
                        " ",
                        " ",
                        "Day ",
                        dayNumber - 1),
                dayNumber < totalDays &&
                    React.createElement("a", { href: "#", className: "btn btn-outline-cta btn-lg d-inline-block", onClick: () => onSwitch(dayNumber + 1) },
                        "Day ",
                        dayNumber + 1,
                        " ",
                        " ",
                        React.createElement("i", { className: "far fa-chevron-right" })))));
    }
}
